import styled, { createGlobalStyle, css, ThemedStyledProps } from 'styled-components';

export const CommonStyle = createGlobalStyle`
    .ant-popover {
      z-index: 3000;
    }

    .ant-toolip {
      z-index: 3001;
    }

    .ant-select-dropdown {
      z-index: 3001;
    }

    .ant-modal-root .ant-modal-wrap {
      z-index: 1002;
    }

    .ant-modal-root .ant-modal-mask {
      z-index: 1001;
    }

    .no-padding-grid {
      padding-right: 0;
      padding-left: 0;
    }
`;

type AnimationProps = {
    animationStyle: React.CSSProperties;
};

export const StyledAnimationDiv = styled.div<AnimationProps>`
    height: 100%;
    width: 100%;
    ${({ animationStyle }: ThemedStyledProps<AnimationProps, any>) => css({ ...animationStyle })};
`;
